module.exports = __webpack_public_path__ + "img/down_arrow.4eeeac95.svg";